'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getBgImgOrColor(bgTitle) {
  if (!bgTitle || !bgTitle.replace(/\s+/g, '')) return {};
  var bg = { backgroundImage: 'url(' + bgTitle + ')' };
  if (bgTitle.indexOf('#') === 0 || bgTitle.indexOf('r') === 0) {
    bg = { backgroundColor: bgTitle };
  }
  return bg;
}

exports.default = getBgImgOrColor;